export const ADD_NUMBER = 'add_number'
export const MINUS_NUMBER = 'minus_number'
export const UPDATE_USER = 'update_user'
export const DELETE_USER = 'delete_user'
export const ADD = 'add'
export const MINUS = 'minius'
export const UPDATE = 'update'
